<div class="card">
    <app-header titulo="Servidores" descricao=""></app-header>
    <button pButton icon="pi pi-plus" label="Novo" (click)="abreDialogServidor()"></button>

    <div class="mt-3">
        <p-table [value]="servidores" dataKey="id" editMode="row" >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:1rem"></th>
                    <th style="width:25%">Nome</th>
                    <th style="width:25%">URL</th>
                    <th style="width:10%">Usuario</th>
                    <th style="width:10%">Senha</th>
                    <th style="width:10%">Status</th>
                    <th style="width:15%"></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-servidor let-editing="editing" let-ri="rowIndex" let-expanded="expanded">
                <tr [pEditableRow]="servidor">
                    <td>
                        <button type="button" pButton [pRowToggler]="servidor" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="servidor.nome" required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ servidor.nome }}
                            </ng-template>
                        </p-cellEditor>
                        
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="servidor.url" required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ servidor.url }}
                            </ng-template>
                        </p-cellEditor>
                        
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="servidor.usuario" required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ servidor.usuario }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="password" [(ngModel)]="servidor.senha" required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                ********
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td><p-tag [value]="servidor.ativo ? 'Ativo' : 'Inativo'" [severity]="servidor.ativo ? 'success' : 'danger'"></p-tag></td>
                    <td>
                        <p-button *ngIf="!editing && servidor.ativo" icon="pi pi-pencil" [rounded]="true" pInitEditableRow [text]="true" severity="info" (click)="editar(servidor)" aria-label="Editar"></p-button>
                        <p-button *ngIf="!editing && servidor.ativo" icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (click)="desativar(servidor)" aria-label="Desativar"></p-button>
                        <p-button *ngIf="!editing && !servidor.ativo" icon="pi pi-check" [rounded]="true" [text]="true" severity="success" (click)="ativar(servidor)" aria-label="Ativar"></p-button>
                        <p-button *ngIf="!editing && servidor.ativo" icon="pi pi-database" [rounded]="true" [text]="true" severity="success" (click)="abreBaseDialog(servidor)" aria-label="Criar base de dados"></p-button>

                        <p-button *ngIf="editing" icon="pi pi-check" [rounded]="true" pSaveEditableRow [text]="true" severity="info" (click)="salvar(servidor)" aria-label="Salvar"></p-button>
                        <p-button *ngIf="editing" icon="pi pi-times" [rounded]="true" pCancelEditableRow [text]="true" severity="danger" (click)="cancelar(servidor, ri)" aria-label="Cancelar"></p-button>
                    </td>

                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-servidor>
                <tr>
                    <td colspan="7">
                        <div class="p-3">
                            <!-- <button pButton icon="pi pi-plus" label="Adicionar base" (click)="abreBaseDialog(servidor)"></button> -->
                            <h6 class="text-blue-700">Base de dados de {{ servidor.nome }}</h6>
                            <p-table [value]="servidor.bases" dataKey="id" editMode="row">
                                <ng-template pTemplate="header">
                                    <tr>
                                        
                                        <th>Cliente</th>
                                        <th>Ambiente</th>
                                        <th>Nome</th>
                                        <th>Usuario</th>
                                        <th>Senha</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-base let-editing="editing" let-ri="rowIndex">
                                    <tr [pEditableRow]="base">
                                        <td>
                                            {{ base.cliente }}
                                        </td>
                                        <td>
                                            {{ base.ambiente }}
                                        </td>
                                        <td>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="base.nome" required>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ base.nome }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        
                                        <td>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="text" [(ngModel)]="base.usuario" required>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ base.usuario }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input pInputText type="password" [(ngModel)]="base.senha" required>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    ********
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td><p-tag [value]="base.ativo ? 'Ativo' : 'Inativo'" [severity]="base.ativo ? 'success' : 'danger'"></p-tag></td>
                                        <td>
                                            <p-button *ngIf="!editing && base.ativo" icon="pi pi-pencil" [rounded]="true" pInitEditableRow [text]="true" severity="info" (click)="editarBase(base)"></p-button>
                                            <p-button *ngIf="!editing && base.ativo" icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (click)="desativarBase(base)"></p-button>
                                            <p-button *ngIf="!editing && !base.ativo" icon="pi pi-check" [rounded]="true" [text]="true" severity="success" (click)="ativarBase(base)"></p-button>
                    
                                            <p-button *ngIf="editing" icon="pi pi-check" [rounded]="true" pSaveEditableRow [text]="true" severity="info" (click)="salvarBase(base)"></p-button>
                                            <p-button *ngIf="editing" icon="pi pi-times" [rounded]="true" pCancelEditableRow [text]="true" severity="danger" (click)="cancelarBase(base, ri)"></p-button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-dialog [(visible)]="servidorDialog" [style]="{width: '450px'}" header="Novo Servidor" [modal]="true" styleClass="p-fluid">
        <ng-template pTemplate="content">
            <div class="field">
                <label for="nome">Nome:</label>
                <input type="text" pInputText id="nome" [(ngModel)]="servidor.nome" required autofocus />
                <small class="p-error" *ngIf="enviadoServidor && !servidor.nome">Nome é obrigatório.</small>
            </div>
            <div class="field">
                <label for="url">Servidor:</label>
                <input type="text" pInputText id="url" [(ngModel)]="servidor.url" required autofocus />
                <small class="p-error" *ngIf="enviadoServidor && !servidor.url">Servidor é obrigatório.</small>
            </div>
            <div class="formgrid grid">
                <div class="field col">
                    <label for="usuario">Usuário:</label>
                    <input type="text" pInputText id="usuario" [(ngModel)]="servidor.usuario" required autofocus />
                    <small class="p-error" *ngIf="enviadoServidor && !servidor.usuario">Usuário é obrigatório.</small>
                </div>
                <div class="field col">
                    <label for="senha">Senha:</label>
                    <input type="password" pInputText id="senha" [(ngModel)]="servidor.senha" required autofocus />
                    <small class="p-error" *ngIf="enviadoServidor && !servidor.senha">Senha é obrigatória.</small>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="escondeDialogServidor()"></button>
            <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvarServidor()"></button>
        </ng-template>
    </p-dialog>


    <app-novabase [baseDialog]="baseDialog" [servidor]="servidor" (fechar)="escondeDialogBase()"></app-novabase>


    <!-- <p-dialog [(visible)]="baseDialog" [style]="{width: '450px'}" header="Nova Base" [modal]="true" styleClass="p-fluid">
        <ng-template pTemplate="content">
            <div class="field">
                <label>Criando no servidor: <b>{{ servidor.nome }}</b></label>
            </div>
            <div class="field">
                <label for="cliente">Cliente:</label>
                <p-dropdown [options]="clientes" optionLabel="razaoSocial" [(ngModel)]="clienteSelecionado" inputId="id" placeholder="Selecione um cliente"></p-dropdown>
                <small class="p-error" *ngIf="enviadoBase && !clienteSelecionado.id">Cliente é obrigatório.</small>
            </div>
            <div class="field">
                <label for="nome">Nome da Base:</label>
                <input type="text" pInputText id="nome" [(ngModel)]="base.nome" required autofocus />
                <small class="p-error" *ngIf="enviadoBase && !base.nome">Nome é obrigatório.</small>
            </div>
            <div class="formgrid grid">
                <div class="field col">
                    <label for="usuario">Usuário:</label>
                    <input type="text" pInputText id="usuario" [(ngModel)]="base.usuario" required autofocus />
                    <small class="p-error" *ngIf="enviadoBase && !base.usuario">Usuário é obrigatório.</small>
                </div>
                <div class="field col">
                    <label for="senha">Senha:</label>
                    <input type="password" pInputText id="senha" [(ngModel)]="base.senha" required autofocus />
                    <small class="p-error" *ngIf="enviadoBase && !base.senha">Senha é obrigatória.</small>
                </div>
            </div>
            
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="escondeDialogBase()"></button>
            <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvarBaseNova()"></button>
        </ng-template>
    </p-dialog> -->
</div>